module.exports = __webpack_public_path__ + "img/second_appointment_button4.2570b8b8.png";